import { useContext } from 'react';

import { MemosProviderContext } from '../memos';

export const useMemosProvider = () => useContext(MemosProviderContext);
